import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function App() {
  const [showScrollTop, setShowScrollTop] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  return (
    <div className="app">
      <header>
        <div className="container">
          <Link to="/" className="logo">
            <i className="fa-solid fa-book-bible"></i> Bible Beacon
          </Link>
          <nav>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </nav>
        </div>
      </header>

      <main>
        {/* Hero Section */}
        <section className="hero">
          <div className="container">
            <h1>Bible Beacon</h1>
            <p>Your personal Bible companion for daily reading, study, and spiritual growth</p>
            <div className="buttons">
              <a href="#download" className="btn primary">
                <i className="fa-solid fa-download"></i> Download Now
              </a>
              <a href="#features" className="btn outline">
                <i className="fa-solid fa-arrow-right"></i> Learn More
              </a>
            </div>
          </div>
        </section>

        {/* Video Section */}
        <section id="demo" className="video-section">
          <div className="container">
            <h2>See Bible Beacon in Action</h2>
            <p>Watch how Bible Beacon can enhance your Bible study experience</p>
            <div className="video-container">
              <iframe 
                src="https://www.youtube.com/embed/eM9rciMk-NA?autoplay=1&mute=1&loop=1&rel=0&controls=1&showinfo=0" 
                title="Bible Beacon App Demo" 
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section id="features" className="features">
          <div className="container">
            <h2>Features</h2>
            <p>Discover what makes Bible Beacon your ideal companion for Bible study</p>
            
            <div className="feature-grid">
              <div className="feature">
                <i className="fa-solid fa-book"></i>
                <h3>Bible Reading</h3>
                <p>Easy navigation through books, chapters, and verses with a clean, distraction-free reading experience.</p>
              </div>
              
              <div className="feature">
                <i className="fa-solid fa-bookmark"></i>
                <h3>Bookmarks & Saved Verses</h3>
                <p>Save your favorite passages and bookmark chapters for easy access during your studies.</p>
              </div>
              
              <div className="feature">
                <i className="fa-solid fa-pen-to-square"></i>
                <h3>Personal Notes</h3>
                <p>Add your own reflections and insights to verses, organized for easy reference later.</p>
              </div>
              
              <div className="feature">
                <i className="fa-solid fa-lightbulb"></i>
                <h3>Verse Explanations</h3>
                <p>Gain deeper understanding with in-depth explanations for every verse, providing context, historical background, and theological insights.</p>
              </div>
            </div>
          </div>
        </section>
        
        {/* Download Section */}
        <section id="download" className="download">
          <div className="container">
            <div className="download-card">
              <h2>Download Bible Beacon Today</h2>
              <p>Begin your journey with Bible Beacon and enhance your Bible study experience.</p>
              <p>Available for iOS and Android devices.</p>
              
              <div className="download-buttons">
                <a href="https://apps.apple.com/us/app/biblebeacon" className="btn primary">
                  <i className="fa-brands fa-apple"></i> App Store
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.biblebeacon" className="btn primary">
                  <i className="fa-brands fa-google-play"></i> Google Play
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer>
        <div className="container" style={{ maxWidth: '1000px' }}>
          <div className="footer-content">
            <div className="footer-logo">
              <i className="fa-solid fa-book-bible"></i> Bible Beacon
            </div>
            <div className="footer-links">
              <Link to="/privacy-policy">Privacy Policy</Link>
            </div>
          </div>
        </div>
      </footer>
      
      {/* Scroll to top button */}
      <a 
        href="#" 
        className={`scroll-to-top ${showScrollTop ? 'visible' : ''}`} 
        onClick={(e) => {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }}
      >
        <i className="fa-solid fa-arrow-up"></i>
      </a>
    </div>
  );
}

export default App;